import Text from '@material-ui/core/Typography';
import TimeLineGraph from '../charts/timelineGraph';
import Slider from '../ui/slider';
import Totals from '../stats/totals';
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import { useData } from '../../dataProvider';
import HeroesInfo from './heroesInfo';
import Grid from '@material-ui/core/Grid';
import '../styles/mainInfo.css';

function MainInfo() {
	const { newAdvantage, wirate_timeline, adv_boost } = useData();

	return (
		<Grid container spacing={2} alignItems="stretch" style={{ height: '100%' }}>
			{/* Левая колонка */}
			<Grid item xs={12} md={5} lg={4} style={{ display: 'flex', flexDirection: 'column' }}>
				<Grid container spacing={2} direction="column" style={{ flexGrow: 1 }}>
					<Grid item style={{ flexGrow: 1 }}>
						<Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
							<CardContent style={{ flexGrow: 1 }}>
								<HeroesInfo />
							</CardContent>
						</Card>
					</Grid>
					<Grid item style={{ flexGrow: 1 }}>
						<Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
							<CardContent style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
								<Grid container justify="center">
									<Grid xs={12} md={10}>
										<Text variant="h6" align='center'>Модель 2</Text>
										<Slider advanatge={adv_boost.toFixed(2)} max={30} />
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Grid>

			{/* Правая колонка */}
			<Grid item xs={12} md={7} lg={8}>
				<Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
					<CardContent
						style={{ flexGrow: 1, alignContent: 'center' }}
					>
						<Grid
							container
							direction="column"
							justifyContent="center" // вертикальное центрирование    // горизонтальное центрирование
							spacing={2}
						>
							<Grid item xs={12} >
								<TimeLineGraph wirate_timeline={wirate_timeline} />
							</Grid>
							<Grid item xs={12} container justify='center'>
								<Grid item xs={12} md={8}>
									<Text variant="h6" align="center">
										Преимущество
									</Text>
									<Slider advanatge={newAdvantage.toFixed(2)} max={30} />
									<Totals />
								</Grid>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid >

	);
}


export default MainInfo;
